import { Room, RoomList, StatsRecorder, StatsDto } from "@domain";
import { Websocket } from "@kernel/frontend-react-app";

export type RoomMeetingLayout = "grid" | "speaker";
export interface RoomState {
  room: Room | null;
  statsRecorder: StatsRecorder | null;
  report: StatsDto | null;
  oldRooms: RoomList;
  localCreated: boolean;
  isStatsRecording: boolean;
  showParticipants: boolean;
  layout: RoomMeetingLayout;
  ws: Websocket | null;
  wsConnected: boolean;
}

export const defaultRoomState: RoomState = {
  room: null,
  statsRecorder: null,
  report: null,
  localCreated: false,
  oldRooms: RoomList.create(),
  isStatsRecording: false,
  showParticipants: false,
  layout: "speaker",
  ws: null,
  wsConnected: false
};
